import { CircularProgress } from "./CircularProgress";

interface MyChallengeCardProps {
  title: string;
  stakeAmount: string;
  progress: number;
  timeLeft: string;
  statusText: string;
  onLogActivity?: () => void;
  onClick?: () => void;
  isSyncing?: boolean;
  isUpcoming?: boolean;
  startsIn?: string;
}

export function MyChallengeCard({
  title,
  stakeAmount,
  progress,
  timeLeft,
  statusText,
  onLogActivity,
  onClick,
  isSyncing = false,
  isUpcoming = false,
  startsIn,
}: MyChallengeCardProps) {
  return (
    <div className="@container">
      <div
        onClick={onClick}
        className={`flex flex-col items-stretch justify-start rounded-3xl bg-background-light dark:bg-background-dark shadow-md dark:shadow-sm dark:shadow-primary/20 ${
          onClick
            ? "cursor-pointer hover:shadow-lg dark:hover:shadow-primary/30 transition-shadow"
            : ""
        }`}
      >
        <div className="p-4 flex flex-col gap-4">
          {/* Header: Title, Stake, and Circular Progress */}
          <div className="flex items-start justify-between gap-4">
            <div className="flex flex-col gap-1">
              <p className="text-slate-900 dark:text-white text-lg font-bold leading-tight tracking-[-0.015em]">
                {title}
              </p>
              <p className="text-slate-500 dark:text-slate-400 text-base font-normal leading-normal">
                Money Committed: {stakeAmount}
              </p>
            </div>
            <CircularProgress percentage={progress} size={64} />
          </div>

          {/* Linear Progress Bar */}
          <div className="w-full h-2 bg-slate-200 dark:bg-slate-700 rounded-full overflow-hidden">
            <div
              className="h-full bg-primary"
              style={{ width: `${progress}%` }}
            />
          </div>

          {/* Footer: Status Info and Log Button */}
          <div className="flex items-end gap-3 justify-between">
            <div className="flex flex-col gap-1">
              <p className="text-slate-500 dark:text-slate-400 text-sm font-normal leading-normal">
                {timeLeft}
              </p>
              <p className="text-slate-500 dark:text-slate-400 text-sm font-normal leading-normal">
                {statusText}
              </p>
            </div>
            {isUpcoming ? (
              <div className="flex items-center gap-2 rounded-full h-10 px-4 bg-slate-200 dark:bg-slate-700">
                <span className="material-symbols-outlined text-base text-slate-600 dark:text-slate-300">
                  schedule
                </span>
                <span className="text-sm font-medium text-slate-600 dark:text-slate-300 truncate">
                  {startsIn}
                </span>
              </div>
            ) : (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  if (!isSyncing && onLogActivity) {
                    onLogActivity();
                  }
                }}
                disabled={isSyncing}
                className={`flex min-w-[84px] max-w-[480px] items-center justify-center overflow-hidden rounded-full h-10 px-4 text-sm font-medium leading-normal transition-opacity ${
                  isSyncing
                    ? "bg-primary/70 text-slate-900/70 cursor-not-allowed"
                    : "bg-primary text-slate-900 cursor-pointer"
                }`}
              >
                {isSyncing ? (
                  <div className="flex items-center gap-2">
                    <div className="w-4 h-4 border-2 border-slate-900/30 border-t-slate-900 rounded-full animate-spin" />
                    <span className="truncate">Syncing...</span>
                  </div>
                ) : (
                  <span className="truncate">Log Activity</span>
                )}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
